var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:_vm.buttonClasses,on:{"click":function($event){_vm.clicked = true}}},[_vm._v("\n  Bereken\n")])}
var staticRenderFns = []

export { render, staticRenderFns }